import { useState, useEffect } from 'react';
import { subscribeDepartments, DEFAULT_DEPARTMENT_NAMES } from '../services/departmentsDb.js';

export function useDepartments() {
  const [departments, setDepartments] = useState(DEFAULT_DEPARTMENT_NAMES);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = subscribeDepartments((names) => {
      setDepartments(names.length ? names : DEFAULT_DEPARTMENT_NAMES);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  return { departments, loading };
}
